(function () {
  var svgLightning = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.426 13.006c-.057 0-.057 0-.115-.006-.633-.070-1.095-.698-1.032-1.402l.61-7.445C7.95 3.5 8.445 3 9.037 3H13.5c.128 0 .254.023.375.070.602.230.922.958.715 1.627L13.1 8.802h2.748c.203 0 .402.060.578.173.55.356.738 1.14.418 1.75-.414.816-4.58 7.816-5.926 10.075-.107.18-.381.092-.37-.117L11 13l-2.573.006z" stroke="#070707" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var svgSparkle   = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M11.456 2.665a.6.6 0 0 1 1.088 0l2.864 6.137a.6.6 0 0 0 .29.29l6.137 2.864a.6.6 0 0 1 0 1.088l-6.137 2.864a.6.6 0 0 0-.29.29l-2.864 6.137a.6.6 0 0 1-1.088 0l-2.864-6.137a.6.6 0 0 0-.29-.29l-6.137-2.864a.6.6 0 0 1 0-1.088l6.137-2.864a.6.6 0 0 0 .29-.29l2.864-6.137z" stroke="#070707" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var svgDroplet   = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 14c0-4.418-8-12-8-12S4 9.582 4 14a8 8 0 1 0 16 0z" stroke="#070707" stroke-width="1.3"/></svg>';
  var iconMap = { lightning: svgLightning, sparkle: svgSparkle, droplet: svgDroplet };

  function tryInit() {
    var dataEl = document.getElementById('cadence-usp-data');
    if (!dataEl) return;

    var firstSlide = document.querySelector('.product__slides .product__slide');
    if (!firstSlide) {
      setTimeout(tryInit, 30);
      return;
    }

    var mobileReorder = dataEl.getAttribute('data-mobile-reorder') === 'true';
    var cardEls = dataEl.querySelectorAll('[data-card-type]');
    if (!cardEls.length) return;

    var productImages = document.querySelector('product-images');
    var slidesHolder  = document.querySelector('.product__slides');
    if (!productImages || !slidesHolder) return;

    var html = '';
    for (var i = 0; i < cardEls.length; i++) {
      var type  = cardEls[i].getAttribute('data-card-type');
      var stat  = cardEls[i].getAttribute('data-stat');
      var icon  = cardEls[i].getAttribute('data-icon');
      var label = cardEls[i].getAttribute('data-label');
      html += '<div class="cusp-card">';
      html += type === 'stat'
        ? '<span class="cusp-stat">' + stat + '</span>'
        : '<span class="cusp-icon-wrap">' + (iconMap[icon] || '') + '</span>';
      html += '<span class="cusp-label">' + label + '</span>';
      html += '</div>';
    }

    var uspCol = document.createElement('div');
    uspCol.id  = 'cadence-usp-col';
    uspCol.setAttribute('aria-hidden', 'true');
    uspCol.innerHTML = html;

    firstSlide.classList.add('cadence-usp-slide');
    slidesHolder.classList.add('cadence-usp-holder');
    productImages.classList.add('cadence-usp-images');
    firstSlide.appendChild(uspCol);

    var photoEl  = firstSlide.querySelector('.product__photo');
    var figureEl = firstSlide.querySelector('.product__photo figure');
    if (photoEl)  photoEl.style.setProperty('--aspect-ratio', '1.125');
    if (figureEl) figureEl.style.setProperty('--aspect-ratio', '1.125');

    var MAX_H = 600;
    var lastH = 0;

    function adjustHeight() {
      if (!photoEl) return;
      var rawH = photoEl.offsetHeight;
      if (rawH === lastH) return;
      lastH = rawH;
      var h = Math.min(rawH, MAX_H);
      productImages.style.setProperty('--height', h + 'px');
      slidesHolder.style.setProperty('--height', h + 'px');
      if (window.innerWidth <= 749) {
        uspCol.style.height        = '';
        uspCol.style.paddingTop    = '';
        uspCol.style.paddingBottom = '';
        return;
      }
      uspCol.style.height        = h + 'px';
      uspCol.style.paddingTop    = '0px';
      uspCol.style.paddingBottom = '0px';
    }

    function updateVisibility() {
      uspCol.style.opacity = firstSlide.classList.contains('media--active') ? '1' : '0';
    }

    requestAnimationFrame(adjustHeight);
    window.addEventListener('load', adjustHeight);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(adjustHeight, 120);
    });

    var allSlides    = document.querySelectorAll('.product__slides .product__slide');
    var slideObserver = new MutationObserver(updateVisibility);
    for (var s = 0; s < allSlides.length; s++) {
      slideObserver.observe(allSlides[s], { attributes: true, attributeFilter: ['class'] });
    }
    window.cadenceUSPSlideObserver = slideObserver;
    updateVisibility();

    var navEls = document.querySelectorAll(
      '.slider__button--prev, .slider__button--next, .product-slider__arrow--prev, .product-slider__arrow--next, .product__thumb__link'
    );
    for (var n = 0; n < navEls.length; n++) {
      navEls[n].addEventListener('click', function () {
        setTimeout(updateVisibility, 80);
      });
    }

    if (mobileReorder) initMobileTopLayout();

    function initMobileTopLayout() {
      var headPlaceholder  = null;
      var pricePlaceholder = null;
      var yotpoPlaceholder = null;
      var layoutTimer      = null;
      var isLayoutDone     = false;
      var yotpoRetryTimer  = null;

      function isMobile()       { return window.innerWidth <= 749; }
      function getProductPage() { return document.querySelector('.product__page'); }
      function getProductHead() { return document.querySelector('.product__block.product__head.block-padding'); }
      function getProductImages() { return document.querySelector('product-images'); }

      function getPriceRowTarget() {
        return document.querySelector('[data-spark="b2c-only"] .product__price__wrap') ||
               document.querySelector('[data-spark="b2c-only"] .product__price-pack');
      }

      function getTopPriceBlock() {
        var priceRow = getPriceRowTarget();
        return priceRow ? priceRow.closest('[data-spark="b2c-only"]') : null;
      }

      function getYotpoReviewEl() {
        return document.querySelector('.product__block.product__head .yotpo.bottomLine') ||
               document.querySelector('.yotpo-widget-clear.yotpo-bottom-line-scroll-panel .yotpo-sr-bottom-line-summary.yotpo-sr-bottom-line-button') ||
               document.querySelector('.yotpo.bottomLine') ||
               document.querySelector('[data-yotpo-element-id] .yotpo-bottom-line');
      }

      function insertAfterBreadcrumbs(yotpo) {
        var breadcrumbs = document.querySelector('.breadcrumbs.product__breadcrumbs');
        if (breadcrumbs && breadcrumbs.parentNode) {
          breadcrumbs.parentNode.insertBefore(yotpo, breadcrumbs.nextSibling);
        } else {
          var pp = getProductPage();
          var ph = getProductHead();
          if (pp && ph) pp.insertBefore(yotpo, ph);
        }
        yotpo.classList.add('cadence-mobile-reviews');
      }

      function waitForYotpo(callback, maxAttempts) {
        maxAttempts = maxAttempts || 50;
        var attempts = 0;
        function checkYotpo() {
          var yotpo = getYotpoReviewEl();
          if (yotpo && yotpo.innerHTML && yotpo.innerHTML.trim() !== '') {
            if (yotpoRetryTimer) clearTimeout(yotpoRetryTimer);
            callback();
            return;
          }
          if (++attempts >= maxAttempts) return;
          yotpoRetryTimer = setTimeout(checkYotpo, 100);
        }
        checkYotpo();
      }

      function createPlaceholders(productHead, priceBlock, yotpo) {
        if (!headPlaceholder && productHead && productHead.parentNode) {
          headPlaceholder = document.createComment('cadence-original-head-position');
          productHead.parentNode.insertBefore(headPlaceholder, productHead);
        }
        if (!pricePlaceholder && priceBlock && priceBlock.parentNode) {
          pricePlaceholder = document.createComment('cadence-original-price-position');
          priceBlock.parentNode.insertBefore(pricePlaceholder, priceBlock);
        }
        if (!yotpoPlaceholder && yotpo && yotpo.parentNode) {
          yotpoPlaceholder = document.createComment('cadence-original-yotpo-position');
          yotpo.parentNode.insertBefore(yotpoPlaceholder, yotpo);
        }
      }

      function moveBlocksAboveSlider() {
        var pp  = getProductPage();
        var ph  = getProductHead();
        var pb  = getTopPriceBlock();
        var pim = getProductImages();
        var yp  = getYotpoReviewEl();

        if (!pp || !ph || !pb || !pim) return false;

        createPlaceholders(ph, pb, yp);

        if (isMobile()) {
          pp.insertBefore(ph, pim);
          pp.insertBefore(pb, pim);
          if (yp) insertAfterBreadcrumbs(yp);
        } else {
          if (headPlaceholder && headPlaceholder.parentNode)
            headPlaceholder.parentNode.insertBefore(ph, headPlaceholder.nextSibling);
          if (pricePlaceholder && pricePlaceholder.parentNode)
            pricePlaceholder.parentNode.insertBefore(pb, pricePlaceholder.nextSibling);
          if (yotpoPlaceholder && yotpoPlaceholder.parentNode && yp) {
            yotpoPlaceholder.parentNode.insertBefore(yp, yotpoPlaceholder.nextSibling);
            yp.classList.remove('cadence-mobile-reviews');
          }
        }
        return true;
      }

      function applyPriceReviewRow() {
        var priceRowTarget = getPriceRowTarget();
        var yp = getYotpoReviewEl();
        if (!priceRowTarget) return false;
        if (!yp) {
          waitForYotpo(function () { applyPriceReviewRow(); });
          return false;
        }

        createPlaceholders(getProductHead(), getTopPriceBlock(), yp);

        var priceEl  = priceRowTarget.querySelector('.product__price');
        var priceOff = priceRowTarget.querySelector('.product__price--off');
        var packEl   = priceRowTarget.querySelector('.product__pack-text');
        if (!priceEl) return false;

        var leftCol = priceRowTarget.querySelector('.cadence-price-left');
        if (!leftCol) {
          leftCol = document.createElement('div');
          leftCol.className = 'cadence-price-left';
          priceRowTarget.insertBefore(leftCol, priceRowTarget.firstChild);
        }

        if (!leftCol.contains(priceEl))              leftCol.appendChild(priceEl);
        if (priceOff && !leftCol.contains(priceOff)) leftCol.appendChild(priceOff);
        if (packEl   && !leftCol.contains(packEl))   leftCol.appendChild(packEl);

        if (!isMobile() && !priceRowTarget.contains(yp)) priceRowTarget.appendChild(yp);

        priceRowTarget.classList.add('cadence-price-row');
        return true;
      }

      function runLayout() {
        if (isLayoutDone) return;
        var yp           = getYotpoReviewEl();
        var moveSuccess  = moveBlocksAboveSlider();
        var priceSuccess = applyPriceReviewRow();
        isLayoutDone = (moveSuccess && priceSuccess) || !!yp;
      }

      function tryLayoutOnce() {
        if (getProductPage() && getProductHead() && getTopPriceBlock() && getProductImages()) {
          runLayout();
          return true;
        }
        return false;
      }

      if (!tryLayoutOnce()) {
        var domObserver = new MutationObserver(function () {
          if (tryLayoutOnce()) domObserver.disconnect();
        });
        domObserver.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { domObserver.disconnect(); }, 5000);
      }

      var yotpoObserver = new MutationObserver(function () {
        var yp = getYotpoReviewEl();
        if (yp && yp.innerHTML && yp.innerHTML.trim() !== '') {
          applyPriceReviewRow();
          if (isMobile() && !document.querySelector('.cadence-mobile-reviews')) {
            insertAfterBreadcrumbs(yp);
          }
          yotpoObserver.disconnect();
        }
      });
      yotpoObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { yotpoObserver.disconnect(); }, 10000);

      window.addEventListener('resize', function () {
        clearTimeout(layoutTimer);
        layoutTimer = setTimeout(function () {
          var ph = getProductHead();
          var pb = getTopPriceBlock();
          var yp = getYotpoReviewEl();
          if (isMobile()) {
            isLayoutDone = false;
            runLayout();
          } else {
            if (headPlaceholder && headPlaceholder.parentNode && ph)
              headPlaceholder.parentNode.insertBefore(ph, headPlaceholder.nextSibling);
            if (pricePlaceholder && pricePlaceholder.parentNode && pb)
              pricePlaceholder.parentNode.insertBefore(pb, pricePlaceholder.nextSibling);
            if (yotpoPlaceholder && yotpoPlaceholder.parentNode && yp) {
              yotpoPlaceholder.parentNode.insertBefore(yp, yotpoPlaceholder.nextSibling);
              yp.classList.remove('cadence-mobile-reviews');
            }
            isLayoutDone = false;
            runLayout();
          }
        }, 150);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

})();
